
export default {
    name: 'FooterComponent',
}
